import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";

import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import {
  SocialMediaPlatform,
  SocialMediaSearch,
} from "@shared/lib/types/influencer";
import { InfluencerService } from "../services/influencer.service";

export function useGetSocialMediaSearch(searchQuery: string, platform: string) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["socialMedias", searchQuery, platform],
    queryFn: () => {
      if (
        searchQuery &&
        [SocialMediaPlatform.Instagram, SocialMediaPlatform.YouTube].includes(
          platform as SocialMediaPlatform
        )
      )
        return InfluencerService.getSocialMedias(
          searchQuery,
          platform as SocialMediaPlatform
        );
      return { data: [] } as unknown as BackednResponse<SocialMediaSearch[]>;
    },
    enabled: Boolean(searchQuery),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    searchedInfluencers: data?.data || [],
    isError,
    isFetching: isLoading,
  };
}
